package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.PreMadeCharacterRepository

/**
 * Compte les pré-tirés proposés sur une table.
 *
 * Utilisé par les écrans qui doivent seulement savoir si des pré-tirés sont disponibles,
 * sans payer le chargement de leurs avatars et de leurs inventaires.
 */
class CountPreMadeCharactersUseCase(
    private val preMadeCharacterRepository: PreMadeCharacterRepository
) {
    suspend operator fun invoke(tableId: String): Result<Int> {
        return preMadeCharacterRepository.countPreMadeCharactersByTableId(tableId)
    }
}
